import { z } from 'zod';

import type {
  Menu,
  PatchAdminV1StoresStoreIdMenusIdBody,
  PostAdminV1StoresStoreIdMenusBody,
} from '@nucleus-commerce/api-client/admin';

const HANDLE = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export const menuFormSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, { error: 'menus:validation.titleRequired' })
    .max(120, { error: 'menus:validation.titleLength' }),
  handle: z
    .string()
    .trim()
    .min(1, { error: 'menus:validation.handleRequired' })
    .max(120, { error: 'menus:validation.handleLength' })
    .regex(HANDLE, { error: 'menus:validation.handleFormat' }),
});

export type MenuForm = z.infer<typeof menuFormSchema>;

export const emptyMenuForm = (): MenuForm => ({ title: '', handle: '' });
export const fromMenu = (menu: Menu): MenuForm => ({ title: menu.title, handle: menu.handle });

export const toMenuCreate = (values: MenuForm): PostAdminV1StoresStoreIdMenusBody => ({
  title: values.title,
  handle: values.handle,
});

export const toMenuUpdate = (values: MenuForm): PatchAdminV1StoresStoreIdMenusIdBody => ({
  title: values.title,
  handle: values.handle,
});
